<template>
  <h4 class="h-decoration" :class="'h-' + position">
    <dv-decoration-3
      v-if="position == 'center' || position !== 'right'"
      style="width: 80px; height: 30px"
    />
    <span>{{ title }}</span>
    <dv-decoration-3
      v-if="position == 'center' || position !== 'left'"
      style="width: 80px; height: 30px"
    />
  </h4>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "center",
    },
  },
};
</script>

<style>
.h-decoration {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f3fbff;
  text-shadow: 0 2px 10px #6ed4ff;
  margin-top: -10px;
  margin-bottom: 0;
  font-size: larger;
}
.h-decoration > span {
  margin: 0 20px;
}

.h-left {
  margin-left: 15px;
  justify-content: flex-start;
}
.h-right {
  margin-right: 15px;
  justify-content: flex-end;
}
</style>
